import React from 'react';
import '../../styles/pages/UnderConstruction.scss';

const UnderConstruction = () => {
    return (
        <div className="under-construction-container">
            <div className="construction-content">
                <div className="construction-scene">
                    <div className="construction-icon">
                        <img src="/assets/images/worker-icon.svg" alt="Çalışma İkonu" />
                    </div>
                </div>
                <h1 className="construction-title">Henüz Yapım Aşamasında</h1>
                <p className="construction-message">
                    Bu özellik üzerinde çalışıyoruz ve yakında sizlerle buluşturacağız!
                </p>
                <div className="construction-details">
                    <div className="progress-indicator">
                        <div className="progress-bar"></div>
                    </div>
                    <p className="return-message">
                        <a href="/" className="return-link">Ana sayfaya dön</a>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default UnderConstruction;